import {
	Route
} from "@/types" // must be imported since file contains an export statement
import {
	config
} from "./config"
import JobDetails from './components/JobDetails.vue'
import TodaysJobs from "./TodaysJobs.vue"

export const route: Route[] = [
	// main route
	{
		path: config.mainRoute.path,
		name: config.mainRoute.name,
		component: config.mainRoute.component,
		meta: {
			module: config.module
		}
	},
	// other routes below
	{
		path: config.todaysJobs.path,
		name: config.todaysJobs.name,
		component: config.todaysJobs.component,
		meta: {
			module: config.todaysModule
		}
	},
	{
		path: `${config.mainRoute.path}/:recordId`,
		name: 'JobDetails',
		component: JobDetails,
		meta: {
			module: config.module
		},
		props: true
	}
]